import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  showLoader,
  hideLoader,
} from "../../actions/CreateCourse/CreatecourseActions";
import ButterflyMark from "./butterflyMark";

const LogoLoader = React.memo(function ComponentPageLoader() {
  const [animation, setAnimation] = useState("");
  useEffect(() => {
    setAnimation("active");
    return () => {
      setAnimation("");
    };
  }, []);
  return (
    <div
      className={`page-loader-comp ${animation}`}
      style={{ zIndex: "10000" }}
    >
      <div className="d-inline-block" style={{ height: "100vh" }}>
        <ButterflyMark />
      </div>
    </div>
  );
});

export const mapStateToProps = (state) => {
  return {
    isLoading: state.coursehome.isLoading,
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(LogoLoader);
